import AuthService from '@/services/authService'
import { toast } from '@/utils/toast'

const user = JSON.parse(localStorage.getItem('user'))

export default {
  namespaced: true,

  state: () => ({
    user: user || null,
    loading: false,
    error: null
  }),

  mutations: {
    setUser(state, data) {
      state.user = data
    },
    clearUser(state) {
      state.user = null
    },
    setLoading(state, status) {
      state.loading = status
    },
    setError(state, error) {
      state.error = error
    }
  },

  actions: {
    async login({ commit }, credentials) {
      commit('setLoading', true)
      commit('setError', null)

      try {
        const response = await AuthService.login(credentials)
        commit('setUser', response.data)
        toast('Logged in successfully')
        return response
      } catch (error) {
        commit('setError', error.response?.data?.message || 'Login failed')
        toast('Login failed', 'error')
        throw error
      } finally {
        commit('setLoading', false)
      }
    },

    async register({ commit }, newUser) {
      commit('setLoading', true)
      commit('setError', null)

      try {
        const response = await AuthService.register(newUser)
        commit('setUser', response.data)
        toast('Registered successfully')
        return response
      } catch (error) {
        commit('setError', error.response?.data?.message || 'Registration failed')
        toast('Registration failed', 'error')
        throw error
      } finally {
        commit('setLoading', false)
      }
    },

    logout({ commit }) {
      AuthService.logout()
      commit('clearUser')
      toast('Logged out')
    }
  },

  getters: {
    isAuthenticated: state => !!state.user,
    currentUser: state => state.user,
    loading: state => state.loading,
    error: state => state.error
  }
}
